import { render, staticRenderFns } from "./JRF3.vue?vue&type=template&id=66966d9c"
import script from "./JRF3.vue?vue&type=script&lang=js"
export * from "./JRF3.vue?vue&type=script&lang=js"
import style0 from "./JRF3.vue?vue&type=style&index=0&id=66966d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports